<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ modelValue: boolean | undefined | null }>();
const emit = defineEmits(['update:modelValue', 'checked']);

const checked = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    emit('checked', value)
  },
});
</script>

<template>
  <label class="relative flex items-center cursor-pointer">
    <!-- Hidden Checkbox -->
    <input type="checkbox" v-model="checked" class="hidden" />

    <!-- Custom Checkbox -->
    <div
      class="w-6 h-6 flex items-center justify-center border-2 border-gray-400 rounded-full transition-all duration-300"
      :class="checked ? 'bg-green-500 border-green-500' : 'bg-white'"
    >
      <svg
        v-if="checked"
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="3"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>
  </label>
</template>
